import { Stack, Typography, IconButton, Modal } from "@mui/material";
import religueImg from "assets/services/religue.png";
import CloseIcon from "@mui/icons-material/Close";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";

export default function InfoReconnect({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        minWidth={"675px"}
        style={{ width: "auto" }}
        borderRadius={"8px"}
      >
        <Stack p={"32px"}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            mb={"18px"}
          >
            <Typography fontSize={"25px"} fontWeight={700} fontStyle={"italic"}>
              RELIGUE
            </Typography>

            <IconButton onClick={onClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          </Stack>
          <Typography
            fontSize={"14px"}
            fontWeight={500}
            color="#636363"
            align="justify"
            lineHeight={"100%"}
          >
            Este serviço é realizado na parte externa do imóvel, portanto não
            necessita do acompanhamento do morador. Para sua segurança, após o
            religue, nosso técnico deixará o registro fechado, evitando
            vazamentos dentro do imóvel, caso tenha ficado aberto o registro de
            um dos queimadores do fogão, por exemplo. Para liberar o gás, você
            pode pedir ajuda do síndico.
          </Typography>
          <Stack alignItems={"center"} mt={"57px"} mb={"57px"}>
            <img
              src={religueImg}
              alt="Serviço de religue"
              style={{
                width: "340px",
                height: "227px",
              }}
            />
          </Stack>
          <Stack borderTop={"1px solid #000000"}>
            <Typography
              fontSize={"25px"}
              fontWeight={700}
              mb={"16px"}
              mt={"30px"}
            >
              Prazos
            </Typography>
            <Typography fontSize={"14px"} fontWeight={600}>
              O prazo para atendimento é de até 2 dias úteis.
            </Typography>
          </Stack>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
